var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMypage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.830078 24.6665C1.43293 20.4541 4.54955 17.2654 8.82638 16.291C8.82638 15.0436 7.74579 14.49 7.56001 14.3611C5.50501 13.1896 4.10594 10.8995 4.10594 8.26438C4.10974 4.43495 7.04816 1.3335 10.6766 1.3335C14.3051 1.3335 17.2435 4.43495 17.2435 8.26059C17.2435 8.32125 17.2359 8.38191 17.2359 8.44258C17.2359 8.46912 17.2435 8.49945 17.2435 8.52599C17.2435 8.52978 17.2322 8.55632 17.2284 8.56391C17.1298 10.9829 15.8596 13.072 13.9942 14.2284C13.9942 14.2284 12.8226 15.3204 13.452 16.2872C13.452 16.2872 16.0757 16.727 17.2397 17.9934",
    stroke: "#484964",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2437 24.2455V19.2559L15.3442 21.3374L13.4219 19.2559V24.2455",
    stroke: "#484964",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7598 19.6768L21.0385 22.1943L23.1693 19.6768",
    stroke: "#484964",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0381 22.1943V24.6664",
    stroke: "#484964",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMypage);
export default __webpack_public_path__ + "static/media/mypage.e35ca7e0e033af5d2cbf4f87f27103f0.svg";
export { ForwardRef as ReactComponent };